import { render, staticRenderFns } from "./details-customer.vue?vue&type=template&id=428430c6&"
import script from "./details-customer.vue?vue&type=script&lang=js&"
export * from "./details-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports